import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import styles from "./textHero.module.css";
import { Button } from "../UI";
import TextReveal, { revealDuration } from "../ANIMATION/TextReveal";
import { EASE } from "../../UTILS/ANIMATION/motionVariants";

// Photo-less page hero on KUR's dark wave texture: the title arrives word by
// word on load, then the lead, actions and any extra content rise in order.
const TITLE_DELAY = 0.2;

const TextHero = ({ id, title, lead, actions = [], children }) => {
  const reduce = useReducedMotion();
  const titleContent = title && title.type === React.Fragment ? title.props.children : title;
  const after = revealDuration(titleContent, TITLE_DELAY) - 0.3;
  const rise = (i) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 22 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.75, delay: after + i * 0.12, ease: EASE },
        };

  return (
    <section className={styles.hero} aria-labelledby={id}>
      <span className={styles.glow} aria-hidden="true" />
      <div className={styles.inner}>
        <TextReveal as="h1" id={id} className={styles.title} delay={TITLE_DELAY} onLoad>
          {titleContent}
        </TextReveal>
        {lead && (
          <motion.p className={styles.lead} {...rise(0)}>
            {lead}
          </motion.p>
        )}
        {actions.length > 0 && (
          <motion.div className={styles.actions} {...rise(1)}>
            {actions.map((a, i) => (
              <Button key={a.href} href={a.href} variant={i === 0 ? "primary" : "secondary"} tone="dark">
                {a.label}
              </Button>
            ))}
          </motion.div>
        )}
        {children && (
          <motion.div className={styles.extra} {...rise(2)}>
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default TextHero;
